/**
 * Dropdown options and constants for Document Extract API
 */

import { CANADA_PROVINCES, USA_PROVINCES } from '../provinces';

// Re-export province data for use in document extraction
export { CANADA_PROVINCES, USA_PROVINCES };

/**
 * License classes for Ontario
 */
export const LICENSE_CLASSES_ONTARIO = [
  'Class A',
  'Class B',
  'Class C',
  'Class D',
  'Class E',
  'Class F'
];

/**
 * License classes for non-Ontario provinces
 */
export const LICENSE_CLASSES_NON_ONTARIO = [
  'Class 1',
  'Class 2',
  'Class 3',
  'Class 4',
  'Class 5'
];

/**
 * All license classes (numeric and letter) for dropdowns after license upload/extraction
 */
export const LICENSE_CLASSES_ALL = [
  ...LICENSE_CLASSES_NON_ONTARIO,
  ...LICENSE_CLASSES_ONTARIO
];

/**
 * Issuing countries for licenses and documents
 */
export const ISSUING_COUNTRIES = [
  { code: 'ca', value: 'Canada' },
  { code: 'us', value: 'USA' }
];

/**
 * Visa types
 */
export const VISA_TYPES = [
  'Student',
  'Work',
  'Tourist',
  'Permanent Resident',
  'Visitor',
  'Business'
];

/**
 * Training certificate names with display names
 */
export const TRAINING_CERTIFICATE_NAMES = [
  { key: 'EmergencyResponseTraining', displayName: 'Emergency Response Training' },
  { key: 'FatigueManagementTraining', displayName: 'Fatigue Management Training' },
  { key: 'HazardousMaterialsEndorsement', displayName: 'Hazardous Materials Endorsement' },
  { key: 'HoursOfService', displayName: 'Hours Of Service' },
  { key: 'MandatoryEntryLevelTraining', displayName: 'Mandatory Entry Level Training' },
  { key: 'MountainDriving', displayName: 'Mountain Driving' },
  { key: 'TransportationOfDangerousGoods', displayName: 'Transportation Of Dangerous Goods' },
  { key: 'VehicleInspections', displayName: 'Vehicle Inspections' },
  { key: 'WinterDriving', displayName: 'Winter Driving' },
  { key: 'WorkplaceHazardousMaterialsInformationSystem', displayName: 'Workplace Hazardous Materials Information System' },
  { key: 'DefensiveDriving', displayName: 'Defensive Driving' },
  { key: 'CargoSecurement', displayName: 'Cargo Securement' }
];

/**
 * Document source authorities mapping
 */
export const DOCUMENT_SOURCES: Record<string, string> = {
  DriverLicense: 'Licensing Authority',
  PRCard: 'IRCC',
  Passport: 'Govt Issued',
  CanadaVisa: 'IRCC',
  USVisa: 'Dept of State',
  WorkPermit: 'IRCC',
  FastCard: 'Border authority',
  HealthCard: '-',
  Abstract: 'Licensing Authority',
  PoliceClearance: 'Police Authority',
  PreEmploymentScreening: 'Screening Company',
  EmploymentHistoryCheck: 'Verification Company',
  OntarioCvorAbstract: 'Ministry of Transportation',
  DrugAlcoholTest: 'Testing Facility',
  RoadTest: 'Licensing Authority',
  DrugAndAlcoholClearingHouseReport: 'FMCSA',
  WsibClearance: 'WSIB',
  ProofOfDelivery: 'Carrier',
  BillOfLading: 'Shipper',
  PapsLabel: 'Customs',
  ParsLabel: 'Customs',
  PoliceReport: 'Police Department',
  DriverAccidentReport: 'Driver',
  RoadsideInspectionReport: 'Inspection Authority',
  Ticket: 'Law Enforcement',
  TicketReceipt: 'Court/Payment Processor',
  RepairInvoice: 'Repair Shop',
  EmergencyResponseTraining: 'Training Organization',
  FatigueManagementTraining: 'Training Organization',
  HazardousMaterialsEndorsement: 'Training Organization',
  HoursOfService: 'Training Organization',
  MandatoryEntryLevelTraining: 'Training Organization',
  MountainDriving: 'Training Organization',
  TransportationOfDangerousGoods: 'Training Organization',
  VehicleInspections: 'Training Organization',
  WinterDriving: 'Training Organization',
  WorkplaceHazardousMaterialsInformationSystem: 'Training Organization',
  DefensiveDriving: 'Training Organization',
  CargoSecurement: 'Training Organization'
};

/**
 * Test result options
 */
export const TEST_RESULTS = [
  'Pass',
  'Fail',
  'Negative',
  'Positive',
  'Pending'
];

/**
 * Boolean options for yes/no fields
 */
export const BOOLEAN_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
];

